import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {NotificationsState} from 'lib/notifications/reducer'

const selectNotificationsFeature = (state: State): NotificationsState => state.notifications

export const isOpen = createSelector(selectNotificationsFeature, notifications => notifications.open)
export const getMessage = createSelector(selectNotificationsFeature, notifications => notifications.message)
